import { CasCRUDTable } from 'src/compass/shared/components';
import PropertyForm from './PropertyForm';

export default function PropertyTab() {
  return (
    <CasCRUDTable
      entityTitle="Property"
      entity="Sce/Claims/Property"
      columns={[
        {
          field: 'property',
          sortable: false,
        },
        {
          field: 'value',
          sortable: false,
        },
      ]}
      showPagination={false}
      showAddButton={false}
      includeExport={false}
      showEditSingletonButton
      editForm={PropertyForm}
      canDelete={false}
    />
  );
}
